module.exports = __webpack_public_path__ + "static/laptop-f40738a3205f75f000a9e46c8c38285d.png";